import {
    CLEAR_VENDOR_FORGOT_RESPONSE,
    VENDOR_CONFIRM_RESET_TOKEN_REQUEST,
    VENDOR_CONFIRM_RESET_TOKEN_SUCCESS,
    VENDOR_FORGOT_PASSWORD_REQUEST,
    VENDOR_FORGOT_PASSWORD_SUCCESS,
    VENDOR_RESET_PASSWORD_REQUEST,
    VENDOR_RESET_PASSWORD_SUCCESS,
} from "./type";

export const vendorForgotPasswordRequest = (cred) => ({
    type: VENDOR_FORGOT_PASSWORD_REQUEST,
    payload: cred,
});

export const vendorForgotPasswordSuccess = (cred) => ({
    type: VENDOR_FORGOT_PASSWORD_SUCCESS,
    payload: cred,
});

export const vendorConfirmResetTokenRequest = (token) => ({
    type: VENDOR_CONFIRM_RESET_TOKEN_REQUEST,
    payload: token,
});

export const vendorConfirmResetTokenSuccess = (cred) => ({
    type: VENDOR_CONFIRM_RESET_TOKEN_SUCCESS,
    payload: cred,
});

export const vendorResetPasswordRequest = (cred) => ({
    type: VENDOR_RESET_PASSWORD_REQUEST,
    payload: cred,
});

export const vendorResetPasswordSuccess = (cred) => ({
    type: VENDOR_RESET_PASSWORD_SUCCESS,
    payload: cred,
});

export const clearVendorForgotResponse = () => ({
    type: CLEAR_VENDOR_FORGOT_RESPONSE,
});
